import moment from 'moment';
import 'react-native-get-random-values';
import {v4 as uuidv4} from 'uuid';
import {Alert} from 'react-native';
import {
  setDataAtPath,
  updateDataAtPath,
  logForCrashlytics,
} from 'src/Utils/fireUtils';
import {getReduxState} from './helpers';

export const setNavigationStartTime = (groupId, locationId) => {
  logForCrashlytics('setNavigationStartTime fired in huntFunctions_v2.js');

  if (groupId && locationId) {
    const path = `scavengerhunt/completions/${groupId}/location_v2/locations/${locationId}/startTime`;
    const startTime = Date.now();

    updateDataAtPath(path, startTime);
  }
};

export const setNavigationCompleteTime = async (
  groupId,
  locationId,
  userId = '',
  location = {},
  distanceAway = 9999,
) => {
  logForCrashlytics('setNavigationCompleteTime fired in huntFunctions_v2.js');
  console.log('setNavigationCompleteTime', {location});
  try {
    // correcting for bar hunt
    if (location?.originalLocation) {
      let path = `scavengerhunt/completions/${groupId}/location_v2/locations/${location?.originalLocation}`;

      let completeTime = Date.now();

      let data = {
        completeTime,
        challengeCompletingUserId: userId,
      };

      if (location?.points) {
        console.log('setting points now');
        data.groupPointsEarned = location?.points;
      }
      await updateDataAtPath(path, data);
    }

    // original location
    let path = `scavengerhunt/completions/${groupId}/location_v2/locations/${locationId}`;

    let completeTime = Date.now();

    let data = {
      completeTime,
      challengeCompletingUserId: userId,
      distanceAway,
      distanceAwayBonusPoints: parseInt(
        Math.max((9999 - distanceAway) / 10, 121),
      ),
    };

    console.log('setting points now', {data});

    // adding bonus points

    return await updateDataAtPath(path, data);
  } catch (error) {
    console.log(error);
  }
};

export const setLocationCompleteTime = (groupId, locationId, userId = '') => {
  logForCrashlytics('setNavigationCompleteTime fired in huntFunctions_v2.js');

  try {
    const path = `scavengerhunt/completions/${groupId}/location_v2/locations/${locationId}`;

    const locationChallengesCompleteTime = Date.now();

    const data = {
      locationChallengesCompleteTime,
      completingUserId: userId,
    };

    return updateDataAtPath(path, data);
  } catch (error) {
    console.log(error);
  }
};

export const setChallengeStartTime = (groupId, challengeId) => {
  logForCrashlytics('setChallengeStartTime fired in huntFunctions_v2.js');

  if (groupId && challengeId) {
    const path = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/startTime`;
    const startTime = Date.now();

    updateDataAtPath(path, startTime);
  }
};

const handleScoreOrChallenge = (nextChallengeId, challenges) => {
  logForCrashlytics('handleScoreOrChallenge fired in huntFunctions_v2.js');

  if (nextChallengeId && challenges[nextChallengeId]?.completeTime) {
    return {
      route: 'LocationChallengeScore',
      params: {
        challengeId: nextChallengeId,
      },
    };
  }
  return {
    route: 'LocationChallenges',
    params: {
      challengeId: nextChallengeId,
    },
  };
};

export const setChallengeCompleteTime = (groupId, challengeId) => {
  logForCrashlytics('setChallengeCompleteTime fired in huntFunctions_v2.js', {
    groupId,
    challengeId,
  });

  if (groupId && challengeId) {
    const path = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/completeTime`;
    const completeTime = Date.now();

    updateDataAtPath(path, completeTime);
  }
};

export const handleBackupLocationClosed = ({
  locationId,
  backupLocationList,
  lastUsedBackUpBar,
  backupLocationForLocation,
  groupId,
}) => {
  logForCrashlytics('handleBackupLocationClosed fired in huntFunctions_v2.js');

  let nextBar;

  console.log('handleBackupLocationClosed', {
    locationId,
    backupLocationList,
    lastUsedBackUpBar,
    backupLocationForLocation,
    groupId,
  });

  if (!backupLocationList || backupLocationList?.length == 0) {
    return Alert.alert(
      'No back up bar exists',
      'Please Contact customer service. ',
    );
  }

  console.log({lastUsedBackUpBar});

  if (!lastUsedBackUpBar) {
    nextBar = backupLocationList[0];
  } else if (lastUsedBackUpBar === backupLocationList[0]) {
    nextBar = backupLocationList[1];
  } else if (lastUsedBackUpBar === backupLocationList[1]) {
    nextBar = null;
  }

  const updatePath = `scavengerhunt/completions/${groupId}/location_v2/locations/${locationId}/backupLocationForLocation`;
  //console.log({nextBar, updatePath})
  setDataAtPath(updatePath, nextBar);
  setDataAtPath(
    `scavengerhunt/completions/${groupId}/location_v2/lastUsedBackUpBar`,
    nextBar,
  );
};

export const markTeamPhotoComplete = ({
  groupId,
  eventId,
  photoUrl,
  userId,
  shareUUID = '',
}) => {
  logForCrashlytics('markTeamPhotoComplete fired in huntFunctions_v2.js');

  const completionPhotoUrlPath = `scavengerhunt/completions/${groupId}/location_v2/teamPhotoUrl`;
  updateDataAtPath(completionPhotoUrlPath, photoUrl);

  const groupPath = `scavengerhunt/groups/${groupId}/`;
  updateDataAtPath(groupPath, {groupPhoto: photoUrl, score: 500});

  updateDataAtPath(groupPath + 'points/teamPhoto', 500);

  // updating group score
  if (eventId) {
    updateDataAtPath(`customEvents/${eventId}/groupScores/${groupId}`, {
      groupId,
      points: 500,
    });
  }

  const photoShareUUIDPath = `scavengerhunt/groups/${groupId}/groupPhotoShareUUID`;
  updateDataAtPath(photoShareUUIDPath, shareUUID);

  const updatedIds = {
    groupId,
    eventId: eventId || null,
  };

  const photoPath = `photos/${groupId}/photos/${shareUUID}`;

  const email = getReduxState(['user', 'info', 'email']);
  const teamName = getReduxState(['groupInfo', 'teamName']);
  const is_test = email?.includes?.('@lets') || teamName?.includes?.('test');

  const photoCompletionObject = {
    shareUUID: shareUUID,
    groupId,
    eventId: eventId || null,
    userId,
    teamName,
    email,
    completionId: uuidv4(),
    challenge: 'Take an epic team photo',
    type: 'Team Photo Challenge',
    date: Date.now(),
    dateFormated: moment().format('YYYY-MM-DDTHH:mm:ss.sssZ'),
    downloadURL: photoUrl,
    is_test,
    photoUrl,
    path: photoPath,
  };

  updateDataAtPath(`photos/${groupId}`, updatedIds);

  updateDataAtPath(photoPath, photoCompletionObject);
};

export const markSelectionChallengeComplete = async ({
  challengeId,
  option,
  correct,
  userId,
  groupId,
  key = null,
  singleCompletion = false,
  allowMultiGuess,
  newMaxPoints,
}) => {
  logForCrashlytics(
    'markSelectionChallengeComplete fired in huntFunctions_v2.js',
  );

  console.log('markSelectionChallengeComplete', {groupId, challengeId});
  if (groupId && challengeId) {
    const path = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/completions/${userId}`;
    const params = {
      option,
      optionKey: key,
      userId,
      answeredCorrectly: correct,
      answeredAt: Date.now(),
      selectedAt: Date.now(),
    };

    console.log({path, params});

    updateDataAtPath(path, params);

    if (newMaxPoints) {
      await updateDataAtPath(
        `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/points/`,
        newMaxPoints,
      );
    }

    ////////////////// JL NOTE
    // this is for classic challenges, so they only get to answer once per group, since the timer isn't active
    if (singleCompletion) {
      const optionSelectPath = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/answers/${
        key || 0
      }`;

      updateDataAtPath(optionSelectPath, {
        selectedByUser: userId,
        selectedAt: Date.now(),
      });

      if (correct || !allowMultiGuess) {
        const completeTime = Date.now();
        const completeTimePath = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/completeTime`;

        updateDataAtPath(completeTimePath, completeTime);
      }
    }
  }
};

export const markChallengeScoreReviewedTime = async (challengeId, groupId) => {
  logForCrashlytics(
    'markChallengeScoreReviewedTime fired in huntFunctions_v2.js',
  );
  const completeTime = Date.now();
  const completeTimePath = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/scoreReviewTime`;

  updateDataAtPath(completeTimePath, completeTime);
};

export const getNavigateNextParams = () => {
  logForCrashlytics('getNavigateNextParams fired in huntFunctions_v2.js');
  const hunt = getReduxState(['game_v2']);

  const {
    locations,
    challenges,
    locationList,
    currentLocationId,
    currentChallengeId,
    screen,
  } = hunt;

  // opening slide, go to first location navigation challenge
  //    add check for if is hunt outro
  if (currentLocationId === null) {
    return {
      route: 'NavigationChallenge',
      params: {locationId: locationList[0]},
    };
  }

  // location complete, go to next location navigation challenge
  //    OR if final location, go to hunt finished
  if (
    currentLocationId &&
    currentChallengeId === null &&
    screen === 'LocationComplete'
  ) {
    const nextLocationIndex = locationList.indexOf(currentLocationId) + 1;
    const notFinalLocation =
      nextLocationIndex && nextLocationIndex < locationList?.length;

    if (notFinalLocation) {
      return {
        route: 'NavigationChallenge',
        params: {locationId: locationList[nextLocationIndex]},
      };
    } else {
      console.log('HuntOutro navigate3');
      return {
        route: 'HuntOutro',
        params: {},
      };
    }
  }

  // navigation score, go to first location challenge
  if (currentLocationId && currentChallengeId === null) {
    const nextChallengeId = locations[currentLocationId]?.challengeList?.[0];

    return handleScoreOrChallenge(nextChallengeId, challenges);
  }

  // location challenge, go to next location challenge
  //   if final challenge, go to location complete
  if (currentLocationId && currentChallengeId) {
    const huntLocation = locations[currentLocationId] || {};
    const {challengeList = []} = huntLocation;

    const nextChallengeIndex = challengeList?.indexOf?.(currentChallengeId) + 1;
    const notFinalChallenge =
      nextChallengeIndex && nextChallengeIndex < challengeList?.length;

    if (notFinalChallenge) {
      const nextChallengeId =
        locations[currentLocationId]?.challengeList?.[nextChallengeIndex];

      return handleScoreOrChallenge(nextChallengeId, challenges);
    } else {
      return {
        route: 'LocationComplete',
        params: {
          locationId: currentLocationId,
        },
      };
    }
  }

  return {route: 'HuntIntro', params: {}};
};

export const getNavigatePrevParams = () => {
  const hunt = getReduxState(['game_v2']);
  logForCrashlytics('getNavigatePrevParams fired in huntFunctions_v2.js');

  const {
    locations,
    challenges,
    locationList,
    currentLocationId,
    currentChallengeId,
    screen,
  } = hunt;

  // opening slide, go to first location navigation challenge
  //   add check for if is hunt outro
  if (currentLocationId === null) {
    return {
      route: 'HuntIntro',
      params: {},
    };
  }

  // navigation challenge, go to prev location complete
  //    OR if first location, go to hunt intro
  if (
    currentLocationId &&
    currentChallengeId === null &&
    screen !== 'LocationComplete'
  ) {
    const prevLocationIndex = locationList.indexOf(currentLocationId) - 1;
    const notFirstLocation = prevLocationIndex >= 0;

    if (notFirstLocation) {
      const prevLocationId = locationList[prevLocationIndex];

      return {
        route: 'LocationComplete',
        params: {locationId: prevLocationId},
      };
    } else {
      return {
        route: 'HuntIntro',
        params: {},
      };
    }
  }

  // location complete, go to last location challenge
  if (
    currentLocationId &&
    currentChallengeId === null &&
    screen === 'LocationComplete'
  ) {
    const huntLocation = locations[currentLocationId] || {};
    const {challengeList = []} = huntLocation;

    const nextChallengeId = challengeList?.[challengeList?.length - 1];
    return handleScoreOrChallenge(nextChallengeId, challenges);
  }

  // location challenge, go to prev location challenge
  //   OR if first challenge, go to navigation challenge
  if (currentLocationId && currentChallengeId) {
    const huntLocation = locations[currentLocationId] || {};
    const {challengeList = []} = huntLocation;

    const nextChallengeIndex = challengeList.indexOf(currentChallengeId) - 1;
    const notFirstChallenge = nextChallengeIndex >= 0;

    if (notFirstChallenge) {
      const nextChallengeId =
        locations?.[currentLocationId]?.challengeList?.[nextChallengeIndex];

      return handleScoreOrChallenge(nextChallengeId, challenges);
    } else {
      return {
        route: 'NavigationChallenge',
        params: {
          locationId: currentLocationId,
        },
      };
    }
  }

  return {route: 'HuntIntro', params: {}};
};

// 3 pontial outcomes
// 1 hunt intro
// 2 navigation challenge
// 3 challenge at location
export const getHighestCompletionParams = () => {
  const hunt = getReduxState(['game_v2']);
  logForCrashlytics('getHighestCompletionParams fired in huntFunctions_v2.js');

  const {locations, challenges, locationList} = hunt;

  // used to see if location challenges started
  var hasStartedLocationChallenges = false;

  const unFinishedLocationIds = locationList.filter((key) => {
    const location = locations[key];
    if (location?.startTime) {
      hasStartedLocationChallenges = true;
    }
    return !location?.locationChallengesCompleteTime;
  });

  // no locations challenges started so showing intro
  if (hasStartedLocationChallenges < 0) {
    return {route: 'HuntIntro', params: {}, highestUnfinshedLocationId: null};
  }

  if (!locationList || !locationList?.length) {
    console.log('no location list loaded yet, cant redirect');
    return {route: 'HuntLoading', params: {}, highestUnfinshedLocationId: null};
  }

  const highestUnfinshedLocationId = unFinishedLocationIds[0];

  // no unfinished challenges so the hunt must be done
  if (!highestUnfinshedLocationId) {
    console.log('HuntOutro navigate2');
    return {route: 'HuntOutro', params: {}, highestUnfinshedLocationId: null};
  }

  console.log({unFinishedLocationIds, highestUnfinshedLocationId});

  const highestUncompletedLocation = locations[highestUnfinshedLocationId];
  const {
    locationId,
    challengeList = [],
    completeTime,
  } = highestUncompletedLocation || {};

  // checking if the navigation challenge was completed
  if (!completeTime) {
    return {
      route: 'NavigationChallenge',
      params: {
        locationId,
      },
      highestUnfinshedLocationId,
    };
  }

  // the navigation challenge was complete, so now finding the index of the highest non-competed challenge
  const highestCompletedChallengeId = challengeList.filter((key) => {
    return !challenges[key]?.completeTime;
  })?.[0];

  console.log({highestCompletedChallengeId});

  if (!highestCompletedChallengeId) {
    return {
      route: 'LocationComplete',
      params: {
        locationId,
      },
      highestUnfinshedLocationId,
    };
  }

  return handleScoreOrChallenge(highestCompletedChallengeId, challenges);
};
